import * as React from "react";
import ArrayUtils from "./util/array";
import { SettingRow, SettingSelect } from "./SettingsWidgets";
var NumDecksSelector = function (props) {
    var handleChange = function (e) {
        var newNumDecks = e.target.value === "" ? null : parseInt(e.target.value, 10);
        props.onChange(newNumDecks);
    };
    return (React.createElement(SettingRow, { label: "Number of decks", htmlFor: "num-decks-selector" },
        React.createElement(SettingSelect, { id: "num-decks-selector", value: props.numDecks === null ? "" : props.numDecks, onChange: handleChange },
            React.createElement("option", { value: "" }, "default"),
            ArrayUtils.range(props.numPlayers, function (idx) {
                var val = idx + 1;
                return (React.createElement("option", { value: val, key: idx }, val));
            }))));
};
export default NumDecksSelector;
